<template>
  <div>
    <div class="contact-info-middle">
      <div class="contact-info-info contact-info-middle-top">
        <div class="contact-info-icon-label">
          <i class="material-icons">phone</i>
          <span class="contact-info-middle-hour">{{getStateWithParam("green_number")}}</span>
        </div>
        <div class="contact-info-right contact-info-nr" @click="openNumberToCall">0800 0 888</div>
      </div>
      <div class="contact-info-info contact-info-middle-bottom">
        <div class="contact-info-icon-label">
          <i class="material-icons">language</i>
          <span class="contact-info-middle-hour">Website</span>
        </div>
        <div
          class="contact-info-right contact-info-adres"
          @click="openInBrowser"
        >{{bashkia_tirane_url}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import native_capacitor from "@/config/js_helper/native_capacitor";
import { BASHKIA_TIRANE_URL } from "@/config/api/url/urls_in_app";
export default {
  name: "ContactBashkiaCard",
  methods: {
    openInBrowser() {
      native_capacitor.openUrl(this.bashkia_tirane_url);
    },
    openNumberToCall() {
      window.open("tel:08000888", "_system");
    },
    getStateWithParam(param) {
      return this.$store.getters.getLanguageParameters(param);
    }
  },
  data() {
    return {
      bashkia_tirane_url: BASHKIA_TIRANE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
.contact-info-middle {
  display: flex;
  flex-direction: column;
  padding: 0 15px 15px 15px;
  font-size: 12px;
  font-weight: 500;
  .contact-info-info {
    display: flex;
    align-items: center;
    &:first-child {
      padding-bottom: 10px;
    }
    .contact-info-icon-label {
      display: flex;
      align-items: center;
      .material-icons {
        font-size: 20px !important;
        color: #e50000;
        padding-right: 5px;
      }
    }
    .contact-info-right {
      margin-left: auto;
    }
    .contact-info-adres {
      color: #0000a2;
    }
    .contact-info-nr {
      color: #007004;
    }
  }
}
.contact-info-bottom {
  font-size: 10px;
  font-weight: 300;
  font-style: italic;
  text-align: center;
  padding-top: 15px;
}
</style>


